import styled from 'styled-components';
import { Card, FlexRow } from 'ui-toolkit';
import React from 'react';
import { JustifyContent } from '../../../../ui-toolkit/theming/types/JustifyContent';

export const StyledDeedMortgageRecordingFees = styled(Card)<{}>`
  box-sizing: border-box;
  left: 22px;
  padding: ${(props) => props.theme.spacing.spacing4};
  top: -${(props) => props.theme.spacing.spacing4};
  width: calc(100% - 114px);
`;

export const StyledDeedMortgageRecordingFeesContainer = styled.div<{}>`
  position: relative;
`;
export const StyledDeedMortgageRecordingFeesCostDataCell = styled.div<{}>`
  width: 120px;
`;

const StyledCell = styled(FlexRow)<{
  justifyContent?: string;
  width?: 'auto' | 'min-content' | 'max-content' | number;
}>`
  position: relative;
  cursor: pointer;
`;

export const StyledDeedMortgageRecordingFeesCell: React.FC<{
  justifyContent?: JustifyContent;
  width?: 'auto' | 'min-content' | 'max-content' | number;
  children?: React.ReactNode;
  onClick?: () => void;
}> = ({ justifyContent = 'space-between', width = 100, onClick, children }) => {
  return (
    <StyledCell justifyContent={justifyContent} width={width} onClick={onClick}>
      {children}
    </StyledCell>
  );
};
